/* eslint-disable react-hooks/exhaustive-deps */
import { Spinner } from "styles/components/common/SpinnerStyle";
import { useState, useEffect } from "react";
import { ButtonGradient } from "styles/common/ButtonStyle";
import { BoxOutline } from "styles/common/BoxStyle";
import { InputGroup, Input } from "styles/common/FormStyle";
import { CommonWrapper } from "styles/common/Layout";
import { getHistory } from "api/sales";
import { formatDateTime, getNdaysAgo, getNow } from "utils/helper";
import { TextBlack } from "styles/common/TextStyle";
import { HistoryWrapper, Log } from "styles/components/home/HistoryStyle";
import useModalStore from "store/modal";
import Receipt from "./Receipt";

const History = () => {
  const [startDate, setStartDate] = useState(getNdaysAgo(7));
  const [endDate, setEndDate] = useState(getNow());
  const [isLoading, setIsLoading] = useState(true);
  const [history, setHistory] = useState(null);
  const modalStore = useModalStore();

  useEffect(() => {
    fetchHistory();
  }, []);

  const handleChangeDate = (event) => {
    if (event.target.type === "date") {
      if (event.target.id === "startDate") {
        setStartDate(event.target.value);
      } else if (event.target.id === "endDate") {
        setEndDate(event.target.value);
      }
    }
  };

  const fetchHistory = async () => {
    try {
      setIsLoading(true);
      const res = await getHistory(startDate, endDate);
      setHistory(res?.data?.result);
    } catch (error) {
      alert(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    fetchHistory();
  };

  const openReceiptModal = (e, sid) => {
    e.preventDefault();
    modalStore.openModal({
      title: "영수증",
      content: <Receipt sid={sid} />,
      gradientHeader: true,
      dense: true,
      dialogClassName: 'max-w-400 min-w-300'
    });
  };

  return (
    <CommonWrapper>
      <HistoryWrapper>
        <InputGroup gap="10px" margin="0 0 10px 0">
          <Input
            type="date"
            fontSize="11px"
            id="startDate"
            value={startDate}
            max={endDate ? endDate : getNow()}
            onChange={handleChangeDate}
          ></Input>
          <Input
            type="date"
            fontSize="11px"
            id="endDate"
            value={endDate}
            min={startDate}
            max={getNow()}
            onChange={handleChangeDate}
          ></Input>
          <ButtonGradient
            width="110px"
            height="40px"
            fontSize="14px"
            fontWeight="500"
            onClick={handleSubmit}
          >
            조회
          </ButtonGradient>
        </InputGroup>
        <BoxOutline>
          {isLoading ||
            (history === undefined && (
              <>
                <Spinner />
                이용 내역을 불러오는 중입니다.
              </>
            ))}
          {!isLoading && (
            <>
              {history?.length === 0 ? (
                <TextBlack size="14px" weight="500" align="center">
                  조회된 내역이 없습니다.
                </TextBlack>
              ) : (
                <>
                  <TextBlack size="16px" weight="700" align="center">
                    이용내역
                  </TextBlack>
                  {history?.map((item) => (
                    <Log onClick={(e) => openReceiptModal(e, item?.sid)} key={item?.sid}>
                      <div className="date">
                        {formatDateTime(item.regdate, "YYYY.MM.DD. HH:mm")}
                      </div>
                      {/* <span className="item"> {item.detergent}</span> */}
                      <span className="price">
                        {" "}
                        {item.buyvolume?.toLocaleString()}mL
                      </span>
                    </Log>
                  ))}
                </>
              )}
            </>
          )}
        </BoxOutline>
      </HistoryWrapper>
    </CommonWrapper>
  );
};

export default History;
